
//#region DevExtreme Imports

import 'devextreme/ui/toolbar'
import 'devextreme/viz/chart'
import 'devextreme/viz/pie_chart'

//#endregion

//#region Service Imports

import { USER_SESSION_SERVICE_NAME } from '../../../services/user-session'
import { $TIMEOUT_SERVICE_NAME } from '../../../services/system'

//#endregion

import { IMRChartController } from "./chart.controller"

//#region Asset Imports

import './chart.scss'
import * as TEMPLATE from './chart.tpl.html'

//#endregion

export const COMPONENT_NAME: string = 'imrChart'

export class IMRChartComponent implements ng.IComponentOptions {
    controller = [$TIMEOUT_SERVICE_NAME, USER_SESSION_SERVICE_NAME, 'measurements', IMRChartController]

    bindings = {
        options: '<'
    } as { [index: string]: string }

    template = TEMPLATE
}
